//services
import {
  signIn as _signIn,
  impersonateUser as _impersonateUser,
  stopImpersonation as _stopImpersonation,
} from '@/services/auth.api.js';

//utils
import sessionManager from '@/utils/managers/sessionManager.js';

//constants
import sessionKeys from '@/utils/sessionKeys.js';

export default {
  async login({ commit }, payload) {
    let { data: userInfo } = await _signIn(payload.username, payload.password);
    if (userInfo) {
      if (userInfo.validator.isValid) {
        commit('setUser', { ...userInfo });
        sessionManager.set(sessionKeys.KEY_USER_PROFILE, { ...userInfo });
      }
      return userInfo;
    }
  },
  async logout() {
    await sessionManager.clearAll();
  },
  async impersonate({ commit, state }, userId) {
    const { data: impersonatedUser } = await _impersonateUser(userId);
    if (impersonatedUser?.validator?.isValid) {
      const nextUser = {
        ...impersonatedUser,
        originalUser: state.user,
      };
      commit('setUser', nextUser);
      sessionManager.set(sessionKeys.KEY_USER_PROFILE, nextUser);
    }
    return impersonatedUser;
  },
  async stopImpersonation({ commit, state }) {
    const originalUser = state.user?.originalUser;
    if (!originalUser) return;

    try {
      await _stopImpersonation();
    } finally {
      commit('setUser', originalUser);
      sessionManager.set(sessionKeys.KEY_USER_PROFILE, originalUser);
    }
  },
};
